import { inject, Injectable, Signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { Country } from '@app/generated-api';
import { CountryService as GeneratedCountryService } from '@app/generated-api/services/CountryService';
import { computedAllDefined, computedAllDefinedNotNull } from '@app/v2/utils/signal-utils';
import { MdsOption } from '@medpacesoftwaredevelopment/designsystem';
@Injectable({
    providedIn: 'root',
})
export class CountrySignalService {
    generatedCountryService = inject(GeneratedCountryService);
    // invoked on service initialization to cache the countries for future use in the app
    readonly countries = rxResource({
        stream: () => this.generatedCountryService.countryGet(), // requirements change: use all countries, not only active countries
    });
    readonly countriesAsMdsOptions = computedAllDefined({ countries: this.countries.value }, ({ countries }) => {
        return countries.map<MdsOption<Country>>((c) => ({ value: c, viewValue: c.name }));
    });
    getCountryByCodeOrName(codeOrName: Signal<string | null | undefined>) {
        return computedAllDefinedNotNull(
            { countries: this.countries.value, codeOrName: codeOrName },
            ({ countries, codeOrName }) => {
                if (codeOrName.length === 0) return null;

                const codeOrNameLowerCase = codeOrName.toLowerCase();
                if (codeOrNameLowerCase.length === 3)
                    return countries.find((c) => c.threeCharCode.toLowerCase() === codeOrNameLowerCase);
                else return countries.find((c) => c.name.toLowerCase() === codeOrNameLowerCase);
            }
        );
    }
}
